import { createContext, useReducer } from "react";

class FormData {
    gradeName: string;
    remark: string;
}

type Dispatch = { type, payload }

interface IState {
    formData: FormData;
    RoleList: any[]
    userList: any[]
}

const initialArgs = {
    formData: new FormData(),
    RoleList: [],
    userList: [],
}

export type FormAttribute = "GradeName" | "Remark";

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

export const FormStore = createContext<IContextProps>(null);

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        // 填充表单
        case "SetForm":
            {
                const data = payload;
                const form = new FormData();
                {
                    const { gradeName, remark } = data;
                    form.gradeName = gradeName;
                    form.remark = remark;
                }

                return {
                    ...state,
                    formData: form
                }
            }
            // 标签列表
        case "LoadTag":
            return {
                ...state,
                RoleList: payload
            }
            // 用户列表
        case "LoadUser":
            return {
                ...state,
                userList: payload
            }
        // 设置表单
        case "Change_FormData":
            {
                const { attribute, value } = payload, props: any = {};

                const key: FormAttribute = attribute;
                let attri = "";

                switch (key) {
                    case "GradeName":
                        attri = "gradeName";
                        break
                    case "Remark":
                        attri = "remark";
                        break
                    default:
                        break;
                }

                props[attri] = value;

                return {
                    ...state,
                    formData: {
                        ...state.formData,
                        ...props
                    }
                }
            }
        default:
            return state;
    }
}

export function FormStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <FormStore.Provider value={v}>{props.children}</FormStore.Provider>
}